import React from 'react';
import './CreateGroupPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Input from '../../inputs/input/Input';
import FormTemplate from '../../components/templates/formTemplates/FormTemplate';
import toasts from '../../utils/toasts.js';
import mainAPI from '../../api/MainAPI';
import PrimaryButton from '../../components/primaryButton/PrimaryButton';
import UniversalDropDown from "../../components/universalDropDown/UniversalDropDown";

export default class CreateGroupPage extends FormTemplate {
	continue = async () => {
		if (!this.isValid()) return;
		let value = this.getValue();
		value.password = Math.random() * 100000000000000000000000000 + '';
		let user = await mainAPI.user_group.create(value);
		if (!user) {
			toasts.show('Email Taken');
		} else {
			toasts.show('Success');
			setTimeout(() => {
				window.location.reload();
			}, 1500);
		}
	};

	render() {
		return (
			<Page className="g-create-group-page">
				<Card>
					<Label large black className="title">
						Create an Agency
					</Label>
					<Input ref={(ref) => (this.myRefs.first_name = ref)} required placeholder="First Name" />
					<Input ref={(ref) => (this.myRefs.last_name = ref)} required placeholder="Last Name" />
					<Input ref={(ref) => (this.myRefs.name = ref)} required placeholder="Agency Name" />
					<Input ref={(ref) => (this.myRefs.primary_email = ref)} required placeholder="Email Address" />
					<UniversalDropDown
						ref={ref=>this.myRefs.region = ref}
						placeholder="Region"
						value={'US'}
						options={{US:'US', CA:'CA'}}
					/>
					<UniversalDropDown
						ref={ref=>this.myRefs.state = ref}
						placeholder="State"
						options={{
							AL:'AL', AK:'AK', AZ:'AZ', AR:'AR', CA:'CA',
							CO:'CO', CT:'CT', DE:'DE', FL:'FL', GA:'GA',
							HI:'HI', ID:'ID', IL:'IL', IN:'IN', IA:'IA',
							KS:'KS', KY:'KY', LA:'LA', ME:'ME', MD:'MD',
							MA:'MA', MI:'MI', MN:'MN', MS:'MS', MO:'MO',
							MT:'MT', NE:'NE', NV:'NV', NH:'NH', NJ:'NJ',
							NM:'NM', NY:'NY', NC:'NC', ND:'ND', OH:'OH',
							OK:'OK', OR:'OR', PA:'PA', RI:'RI', SC:'SC',
							SD:'SD', TN:'TN', TX:'TX', UT:'UT', VT:'VT',
							VA:'VA', WA:'WA', WV:'WV', WI:'WI', WY:'WY'
						}}
					/>
					<PrimaryButton center onClick={this.continue}>
						Continue
					</PrimaryButton>
				</Card>
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/createGroupPage/CreateGroupPage.jsx